import React from 'react';

import {
  AttributeItem,
  AttributeList,
} from 'scenes/Gallery/components/AttributeList';

const CreativeAttributes = ({
  isOriginal,
  creativeType,
  fileExtension,
  fileVideoLength,
  fileWidth,
  fileHeight,
  fileSize,
  fileOrientation,
  fileRatio,
  flexWrap,
}) => {
  return (
    <AttributeList
      type={'text'}
      listSeparator={'|'}
      justifyContent={'center'}
      flexWrap={flexWrap}
    >
      {isOriginal != null ? (
        <AttributeItem value={isOriginal ? 'Original' : 'Variant'} />
      ) : null}
      <AttributeList type={'text'} listSeparator={'/'}>
        {creativeType ? (
          <AttributeItem valueParser={'creativeType'} value={creativeType} />
        ) : null}
        {fileExtension ? (
          <AttributeItem valueParser={'fileExtension'} value={fileExtension} />
        ) : null}
      </AttributeList>
      {fileVideoLength ? (
        <AttributeItem
          valueParser={'fileVideoLength'}
          value={fileVideoLength}
        />
      ) : null}
      {fileWidth && fileHeight ? (
        <AttributeItem
          valueParser={'fileResolution'}
          value={{ width: fileWidth, height: fileHeight }}
        />
      ) : null}
      {fileSize ? (
        <AttributeItem valueParser={'fileSize'} value={fileSize} />
      ) : null}
      {fileOrientation ? <AttributeItem value={fileOrientation} /> : null}
      {fileRatio ? <AttributeItem value={fileRatio} /> : null}
    </AttributeList>
  );
};

export default CreativeAttributes;
